import React, { useEffect, lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';
import VehicleDetail from './pages/VehicleDetail';
import ChatWidget from './components/ChatWidget';
import WhatsAppButton from './components/WhatsAppButton';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Admin from './pages/Admin';
import VehicleManagement from './pages/VehicleManagement';
import AdminBookings from './pages/AdminBookings';

// Loading component for lazy routes
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#FDB913]"></div>
      <p className="mt-4 text-gray-600">Lädt...</p>
    </div>
  </div>
);

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === '/login';

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ErrorBoundary>
      <>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fahrzeug/:id" element={<VehicleDetail />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/vehicles" element={<VehicleManagement />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        </Routes>
        <Toaster />
        {/* Show Chat and WhatsApp only on public pages */}
        {!isAdminRoute && (
          <>
            <ChatWidget />
            <WhatsAppButton />
          </>
        )}
      </>
    </ErrorBoundary>
  );
}

function App() {
  useEffect(() => {
    // Lightweight error suppression for Safari
    const suppressError = (e) => {
      // Don't show error overlays
      e.stopPropagation();
      e.preventDefault();
      console.log('[Error suppressed]:', e.type);
      return false;
    };

    // Capture errors in capture phase
    window.addEventListener('error', suppressError, true);
    window.addEventListener('unhandledrejection', suppressError, true);

    return () => {
      window.removeEventListener('error', suppressError, true);
      window.removeEventListener('unhandledrejection', suppressError, true);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;